exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1[_v-0ea55b52],span.beleive[_v-0ea55b52]{color:#25b7ea!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-0ea55b52&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/pages/consumers.vue
 ** module id = 19
 ** module chunks = 0
 **/